












import KeyStatsChart from "@/components/KeyStatsChart.vue";
import KeyName from "@/components/KeyName.vue";
import { KeyStats, KeyCat } from "@/types/debug-mode";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: { KeyStatsChart, KeyName },
})
export default class KeyStatsSingle extends Vue {
  created() {
    // Check for cached stats
    if (!this.keyStats[this.keyName]) {
      // if not cached, fetch stats
      this.$store.dispatch("debugMode/fetchKeyStats", this.keyName);
    }
  }

  @State(state => state.debugMode.keyStats) keyStats!: KeyStats;

  @Prop({ required: true })
  keyName!: string;

  @Prop({ required: true })
  keyCat!: KeyCat;

  get stats() {
    return this.keyStats[this.keyName];
  }

  get hasStats() {
    return this.stats && this.stats.length > 0;
  }
}
